/**
 * Static SEO metadata for /services/:slug — used for the <Seo /> tag
 * in every state (loading + loaded). Client-supplied exact copy.
 * Keep slugs in sync with backend service catalogue.
 */
export const SERVICE_SEO = {
  "private-limited": {
    title: "Private Limited Company Registration in Mumbai",
    short:
      "Register a Private Limited company in Mumbai with founder-led guidance on structure, MOA and compliance. Best fit for startups planning to raise capital.",
  },
  "llp": {
    title: "LLP Registration in Mumbai, Navi Mumbai & Thane",
    short:
      "Set up an LLP in Mumbai, Navi Mumbai or Thane. A lean partnership with limited liability, plus clear advice on whether it suits your business.",
  },
  "opc": {
    title: "One Person Company (OPC) Registration in Mumbai",
    short:
      "Solo founder? Register a One Person Company in Mumbai and get a corporate identity with limited liability. Founder-led support at every step.",
  },
  "startup-india-dpiit": {
    title: "Startup India DPIIT Recognition Support in Mumbai",
    short:
      "Get DPIIT recognition under Startup India and access tax exemptions and government schemes. Founder-led help for startups in Mumbai and the MMRDA region.",
  },
  "gst-msme-compliance": {
    title: "GST, MSME & ROC Compliance Services in Mumbai",
    short:
      "GST, MSME and ROC compliance for new businesses in Mumbai. Stay compliant from day one with founder-led support long after incorporation.",
  },
  "business-presence": {
    title: "Domain, Email & Website Setup for New Startups",
    short:
      "Launch-ready basics for new businesses: domain, workspace email, website and brand setup, done alongside your company registration.",
  },
};
